import React from 'react';
import { clsx } from 'clsx';
import styles from './EmptyState.module.css';
import { Button } from '../Button';

interface EmptyStateProps {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  action?: {
    label: string;
    onClick: () => void;
  };
  actions?: React.ReactNode;
  /** Tighter padding + smaller title/icon for inline placements. */
  compact?: boolean;
}

export function EmptyState({
  icon,
  title,
  description,
  action,
  actions,
  compact = false,
}: EmptyStateProps) {
  return (
    <div className={clsx(styles.container, compact && styles.containerCompact)}>
      {icon && <div className={clsx(styles.icon, compact && styles.iconCompact)}>{icon}</div>}
      <h3 className={clsx(styles.title, compact && styles.titleCompact)}>{title}</h3>
      {description && (
        <p className={clsx(styles.description, compact && styles.descriptionCompact)}>
          {description}
        </p>
      )}
      {actions ? (
        <div className={styles.actions}>{actions}</div>
      ) : action ? (
        <Button variant="primary" onClick={action.onClick} className={styles.action}>
          {action.label}
        </Button>
      ) : null}
    </div>
  );
}
